import React from 'react'
import AgTechHeaderDetail from '@agtech/web/components/Headers/AgTechHeaderDetail';
import AgTechBadgedTabPage from '@agtech/web/components/Pages/Tabbed/Flavors/AgTechBadgeTabPage';
import { SaleContactDetails } from '@sales/data/operation/contacts/SaleContactData'
import { getSaleContactCreditsTabPageProps } from './SaleContactCreditsTabPage';
import { AgTechTabPageProps } from '@agtech/web/components/Pages/Tabbed/AgTechTabPage';
import { IndexLength } from '@agtech/core/utilities/AgTechUtilities';
import ContactNotesCardCollection from '@agtech/web/integrations/contacts/components/cards/ContactNotesCardCollection';
import ContactNoteDialog from '@agtech/web/integrations/contacts/dialogs/notes/ContactNoteDialog';
import { ContactGeneralInformationTab } from '@agtech/web/integrations/contacts/pages/ContactMasterDetailPage';

export const getSaleContactDetailTabPageProps = (props: { contactDetails: SaleContactDetails }): AgTechTabPageProps => {
    const contactDetails = props.contactDetails;
    const contactNotes = contactDetails.notes ?? {};
    const contactCredits = contactDetails.credits ?? {};

    return {
        tabs: [
            { text: 'General', content: () => ContactGeneralInformationTab({ contact: contactDetails }) },
            { text: 'Notes', displayText: `Notes (${IndexLength(contactNotes)})`, content: () => <SaleContactNotesTab contactDetails={contactDetails} /> },
            { text: 'Credits', displayText: `Credits (${IndexLength(contactCredits)})`, content: () => <SaleContactCreditsTab contactDetails={contactDetails} /> }
        ]
    }
}

const SaleContactNotesTab = (props: { contactDetails: SaleContactDetails }) => {
    return (
        <div className='stretched flex'>
            <ContactNotesCardCollection
                contactDetails={props.contactDetails}
                customize={collectionProps => ({
                    ...collectionProps,
                    settings: {
                        ...collectionProps.settings,
                        header: () => (
                            <AgTechHeaderDetail
                                header={`Notes (${IndexLength(props.contactDetails.notes)})`}
                                settings={{
                                    header: {
                                        classes: '!text-plus'
                                    },
                                    content: {
                                        body: () => (
                                            <ContactNoteDialog.Button
                                                contactId={props.contactDetails.contact.id}
                                                classes='ml-auto button-highlight'
                                            />
                                        )
                                    }
                                }}
                            />
                        )
                    }
                })}
            />
        </div>
    )
}

const SaleContactCreditsTab = (props: { contactDetails: SaleContactDetails }) => {
    return (
        <AgTechBadgedTabPage
            {...getSaleContactCreditsTabPageProps({ contactDetails: props.contactDetails })}
        />
    )
}